import React from "react";

// Shared loading primitives. Use these everywhere instead of inline
// "Loading…" text so the dashboard feels consistent. Inline styles only —
// the shimmer + spin keyframes are injected once below so no CSS file edit
// is required.

export function Skeleton({ height = 16, width = "100%", radius = 6, style }) {
  return (
    <div
      className="bl-skel"
      style={{
        height,
        width,
        borderRadius: radius,
        background:
          "linear-gradient(90deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.10) 50%, rgba(255,255,255,0.04) 100%)",
        backgroundSize: "200% 100%",
        animation: "bl-skel-shimmer 1.4s ease-in-out infinite",
        ...style,
      }}
    />
  );
}

export function Spinner({ size = 18, color = "var(--bl-accent)", style }) {
  return (
    <span
      aria-label="loading"
      style={{
        display: "inline-block",
        width: size,
        height: size,
        border: "2px solid rgba(255,255,255,0.12)",
        borderTopColor: color,
        borderRadius: "50%",
        animation: "bl-spinner 0.75s linear infinite",
        verticalAlign: "middle",
        ...style,
      }}
    />
  );
}

// Drop-in row of skeletons for a table body. Matches column count to the
// header — pass `cols` to control width count.
export function SkeletonRows({ rows = 4, cols = 4 }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, r) => (
        <tr key={r} style={{ borderBottom: "1px solid var(--bl-line)" }}>
          {Array.from({ length: cols }).map((_, c) => (
            <td key={c} style={{ padding: "0.75rem 1rem" }}>
              <Skeleton height={14} width={c === 0 ? "60%" : c === cols - 1 ? "40%" : "75%"} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}

// Injected once at module load. Doing it as an effect would mean the keyframes
// don't exist until the first component mounts. This is a one-shot side effect.
if (typeof document !== "undefined" && !document.getElementById("bl-loading-keyframes")) {
  const style = document.createElement("style");
  style.id = "bl-loading-keyframes";
  style.textContent = `
    @keyframes bl-skel-shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
    @keyframes bl-spinner { to { transform: rotate(360deg); } }
  `;
  document.head.appendChild(style);
}

const LoadingStates = { Skeleton, Spinner, SkeletonRows };
export default LoadingStates;
